import React from 'react';
import PropTypes from 'prop-types';

import DetailNav from './DetailNav';
import { createSkeletonItem } from '../Skeleton/SkeletonHelpers';

import './DetailHeader.scss';
import '../Modal/ModalHeader.scss';

const DetailHeader = ({
  headerClassName,
  title,
  data,
  navBtns,
  navClassName,
}) => {
  const {
    titleParts,
    subtitles,
    tags,
    btns,
    components,
  } = data || {};

  // If title is undefined, don't render the header at all
  if (title === undefined) {
    return null;
  }

  return (
    <div className={`detailHeader ${headerClassName || ''}`}>
      <div className="detailHeader__text">
        <h2 className="detailHeader__title">

          { title }

          { titleParts?.map((item) => (
            <span className="detailHeader__titlePart" key={item}>
              {` - ${item}`}
            </span>
          ))}

          { tags?.map((item) => (
            <span
              key={item.type}
              className={`detailHeader__tag detailHeader__tag--${item.type} detailHeader__tag--paneTag`}
            >
              {item.text}
            </span>
          ))}

          {components?.length > 0 && components.map((component, idx) => (
            React.isValidElement(component)
              ? React.cloneElement(component, { key: `component-${idx}` })
              : <React.Fragment key={`component-${idx}`}>{component}</React.Fragment>
          ))}

        </h2>

        { (
          (subtitles?.length > 0 || btns?.length > 0 || components?.length > 0
          || subtitles === null)
        ) && (

          <h3 className="detailHeader__subtitle">

            { subtitles?.map((item, index) => ((
              <span
              // eslint-disable-next-line react/no-array-index-key
                key={`subtitle-${index}`}
                className="detailHeader__subtitleGroup"
              >
                {item}
              </span>
            )))}

            { createSkeletonItem('span', 'detailHeader__subtitleGroup', 'medium', subtitles === null) }

            { btns?.map((item, index) => (
              <button
              // eslint-disable-next-line react/no-array-index-key
                key={`btn-${item.text}-${index}`}
                type="button"
                className={item.className}
                onClick={item.onClick}
              >
                {item.text}
              </button>
            ))}
          </h3>
        ) }

      </div>
      <DetailNav
        className={navClassName}
        navBtns={navBtns}
      />
    </div>
  );
};

DetailHeader.propTypes = {
  headerClassName: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.shape({
    titleParts: PropTypes.arrayOf(PropTypes.string),
    subtitles: PropTypes.arrayOf(PropTypes.string),
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      }),
    ),
    btns: PropTypes.arrayOf(
      PropTypes.shape({
        className: PropTypes.string,
        onClick: PropTypes.func,
        text: PropTypes.string.isRequired,
      }),
    ),
    components: PropTypes.arrayOf(PropTypes.node),
  }),
  navBtns: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  navClassName: PropTypes.string,
};

DetailHeader.defaultProps = {
  // title: intentionally omitted - will be undefined unless explicitly passed. Only show skeleton when explicitly set to null
  headerClassName: null,
  data: null,
  // navBtns: intentionally omitted - will be undefined unless explicitly passed. Only show skeleton when explicitly set to null
  navClassName: null,
};

export default DetailHeader;
